// Mock data for testing frontend
export const mockData = {
  company: {
    name: 'SIA "Tīrīšana"',
    phone: '23331106',
    email: 'artjoms.casnovics@gmail.com',
    workingHours: 'P. - Sv. 7:00 - 21:00',
    responseTime: 'Atbildam 3h laikā',
    instagram: 'https://www.instagram.com/tirisanasia/',
    facebook: 'https://www.facebook.com/profile.php?id=61579879372803',
    tiktok: 'https://www.tiktok.com/@tirisanasia',
    logo: 'https://customer-assets.emergentagent.com/job_window-care/artifacts/3kgkaml3_LOGO%20W%20SLOGAN%20WO%20BG.png'
  },

  services: [
  {
    id: 1,
    title: 'Logu mazgāšana',
    description: 'Profesionāla logu tīrīšana no iekšpuses un ārpuses. Izmantojam kvalitatīvus līdzekļus un profesionālus instrumentus.',
    icon: 'Sparkles',
    features: ['No iekšpuses', 'No ārpuses', 'Bez švīkām', 'Bez punktiņiem']
  },
  {
    id: 2,
    title: 'Vitrīnu tīrīšana',
    description: 'Uzņēmumu vitrīnu profesionāla tīrīšana, lai jūsu bizness izskatītos pievilcīgi un uzticami.',
    icon: 'Store',
    features: ['Veikalu vitrīnas', 'Biroju stikli', 'Viesnīcas', 'Restorāni']
  },
  {
    id: 3,
    title: 'Rāmju un palodžu tīrīšana',
    description: 'Pilnīga logu aprūpe - ne tikai stikli, bet arī rāmji, gumijas, stūrīši, palodzes, insektu sietiņi, rāmju ailes un vērtnes (pasūtot logu tīrīšanu no iekšpuses). Viss būs nevainojami tīrs.',
    icon: 'SquareStack',
    features: ['Plastikāta logi', 'Koka rāmji', 'Alumīnija rāmji', 'Citi']
  },
  {
    id: 4,
    title: 'Regulārā apkope',
    description: 'Abonēšanas iespēja uzņēmumiem un privātpersonām. Regulāra apkope par izdevīgu cenu.',
    icon: 'Calendar',
    features: ['Iknedēļas tīrīšana', 'Ikmēneša tīrīšana', 'Sezonas līgumi', 'Individuāls plāns']
  }],


  testimonials: [
  {
    id: 1,
    name: 'Jānis V.',
    role: 'Google atsauksme',
    text: 'Darbu var raksturot divos vārdos - kvalitāte un atbildība. Iesaku!',
    rating: 5,
    timeAgo: 'Pirms 6 dienām'
  },
  {
    id: 2,
    name: 'Inga G.',
    role: 'Google atsauksme',
    text: 'Ļoti kārtīgi notīra logus. Švīkas neredzu kad uzspīd saule - tas ir rādītājs!',
    rating: 5,
    timeAgo: 'Pirms 2 nedēļām'
  },
  {
    id: 3,
    name: 'Svetlana R.',
    role: 'Google atsauksme',
    text: 'Ļoti labi puiši! Esmu jau divas reizes izmantojusi viņu pakalpojumus un esmu ļoti apmierināta: mani logi tika rūpīgi iztīrīti. Viņi atbrauc ar garām kāpnēm, visu nepieciešamo aprīkojumu un tīrīšanas līdzekļiem. Ceru, ka varēsim turpināt sadarboties uz pozitīvas puses! Paldies par jūsu palīdzību!',
    rating: 5,
    timeAgo: 'Pirms 2 nedēļām'
  }],


  serviceTypes: [
  { value: 'logu_mazgasana', label: 'Logu mazgāšana' },
  { value: 'vitrinu_mazgasana', label: 'Vitrīnu mazgāšana' },
  { value: 'cita_veida', label: 'Cita veida stiklu mazgāšana' }],


  buildingTypes: [
  { value: 'privatmaja', label: 'Privātmāja' },
  { value: 'dzivoklis', label: 'Dzīvoklis' },
  { value: 'birojs', label: 'Birojs' }],


  buildingSizes: [
  { value: 'maza', label: 'Mazā (līdz 10 logiem)' },
  { value: 'videja', label: 'Vidējā (10-20 logi)' },
  { value: 'liela', label: 'Lielā (20+ logi)' }],


  floors: [
    { value: 'pirmais', label: 'Tikai pirmais stāvs' },
    { value: 'augstaki', label: 'Ir arī otrā vai augstākā stāva logi' }
  ],
  
  floorsApartment: [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5+', label: '5+' }
  ],


  vitrinaSizes: [
  { value: 'maz', label: 'Maz (1-3 stikli)' },
  { value: 'vidēji', label: 'Vidēji (4-8 stikli)' },
  { value: 'daudz', label: 'Daudz (9+ stikli)' }],


  washingFrequency: [
  { value: 'vienreizeja', label: 'Vienreizējā mazgāšana' },
  { value: 'menesi', label: 'Vienreiz mēnesī' },
  { value: 'divreiz', label: 'Divreiz mēnesī' },
  { value: 'nedelu', label: 'Katru nedēļu' }],


  windowAccess: [
  { value: 'pirmais', label: 'Visi logi atrodas pirmā stāva līmenī' },
  { value: 'augstaki', label: 'Daži vai visi logi ir otrā stāva līmenī vai augstāk' }]

};